import { createEvent, restore } from 'effector'
import { Properties } from '../list/types'

export const setProperties = createEvent<Properties | null>()

export const $property = restore(setProperties, null)
